import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
// 礼物列表
type GiftList = {
  gift_id?: number
  name?: string
  icon?: string
  score?: number
}
// 中奖列表
type AwardList = {
  mid?: number
  name?: string
  avatar?: string
  coins?: number
  time?: string
}
// 跑马灯播报
type AwardMarquee = {
  id?: number
  mid?: number
  name?: string
  gift_id?: number
  gift_cnt?: number
  gift_icon?: string
  mag?: number // 中奖倍数
  score?: number
}
type homeType = {
  total?: number // jp奖池数
  countdown?: number // 倒计时
  gift_list?: Array<GiftList> // 礼物列表
  award_list?: Array<AwardList> // 中奖列表
  marquee_list?: Array<AwardMarquee> // 跑马灯播报
  strongest_user?: AwardList // 最强玩家
}

export const jp_homepage = createAsyncThunk(
  'jp_homepage',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<homeType>>(
      '/live/gift/jp_homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface InitialStateType {
  pageData: {
    total?: number // jp奖池数
    countdown?: number // 倒计时
    gift_list?: Array<GiftList> // 礼物列表
    award_list?: Array<AwardList> // 中奖列表
    marquee_list?: Array<AwardMarquee> // 跑马灯播报
    strongest_user?: AwardList // 最强玩家
  }
}

const initialState: InitialStateType = {
  pageData: {},
}

export const LuckyJackpotSlice = createSlice({
  name: 'LuckyJackpot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(jp_homepage.fulfilled, (state, action) => {
      Object.assign(state, {pageData: action.payload})
    })
  },
})
export default LuckyJackpotSlice.reducer
export const LuckyJackpotActions = LuckyJackpotSlice.actions
